import { render, staticRenderFns } from "./VideoLibrary.vue?vue&type=template&id=2487d90e&scoped=true&"
import script from "./VideoLibrary.vue?vue&type=script&lang=js&"
export * from "./VideoLibrary.vue?vue&type=script&lang=js&"
import style0 from "./VideoLibrary.vue?vue&type=style&index=0&id=2487d90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2487d90e",
  null
  
)

export default component.exports